// extracted by mini-css-extract-plugin
module.exports = {"timeBar":"CalendarTime_timeBar__3FyZq","divider":"CalendarTime_divider__5gC3T","upcomingTime":"CalendarTime_upcomingTime__27aex","spin360":"CalendarTime_spin360__1xcSv"};